<div [class]="styleClass">
  <textarea class="text-area text-area__input-field"></textarea>
</div>
